import Slider from '../modules/Slider';

export default {
  init() {

    $('.js-slider').each((index, el) => {
      new Slider(el);
    });

    $('.posts-grid__description').matchHeight();

    //Mobile footer
    $(document).on('click', '.menu-item-has-children > .menu-item__icon', function () {
      $(this).toggleClass('open')
      $(this).parent().find('.sub-menu').slideToggle()
    });

    $(document).on('click', '.main-footer__info--label .menu-item__icon', function () {
      $(this).toggleClass('open')
      $(this).parent().parent().find('.main-footer__info--content').slideToggle()
    });

    //Mobile main menu
    $('#banner__burger-menu').click(function () {
      $(this).toggleClass('menu-on');
      $('.banner__nav-primary').slideToggle()
    });

    //open sub menu
    $(document).on('click', '.sub-menu-icon', function (e) {
      e.preventDefault();
      $(this).toggleClass('open');
      $(this).parent().parent().find('.sub-menu').slideToggle();
    });

    //Hover menu
    $('#menu-main-menu .menu-item-has-children').hover(function () {
      if ($(window).width() > 768) {
        $(this).find('.sub-menu').show();
      }
    }, function () {
      if ($(window).width() > 768) {
        $(this).find('.sub-menu').hide();
      }
    });

    // scroll for top hero module on icon click
    $(document).on('click', '.js-top-hero__sroll', function () {
      let targetScroll = $(this).parent().next();
      let heightHeader = $('header.banner').outerHeight(true)
      $('html, body').animate({
        scrollTop: targetScroll.offset().top - heightHeader,
      }, 500, 'linear')
    });

    // Homepage specific - scroll for top hero module on icon click
    $(document).on('click', '.homepage-top-hero .js-top-hero__sroll', function () {
      let targetScroll = $('#what-we-do');
      let heightHeader = $('header.banner').outerHeight(true)
      $('html, body').animate({
        scrollTop: targetScroll.offset().top - heightHeader,
      }, 500, 'linear')
    });


    $(document).on('click', '.floating-box-contact .poparrow', function () {
      $('.floating-box-contact .popout').show();
      $('.floating-box-contact').addClass('popoutvisible');
      $('.floating-box-contact .poparrow').hide();
      $('.floating-box-contact .poparrowclose').show();
    });
    $(document).on('click', '.floating-box-contact .poparrowclose', function () {
      $('.floating-box-contact .popout').hide();
      $('.floating-box-contact').removeClass('popoutvisible');
      $('.floating-box-contact .poparrow').show();
      $('.floating-box-contact .poparrowclose').hide();
    });
    if ($('.floating-box-contact .poparrow').length) {
      $('.floating-box-contact .poparrow').trigger('click');
    }


    $('a[href*="#"]')
      // Remove links that don't actually link to anything
      .not('[href="#"]')
      .not('[href="#0"]')
      .click(function (event) {
        // On-page links
        if (
          location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
          &&
          location.hostname == this.hostname
        ) {
          // Figure out element to scroll to
          var target = $(this.hash);
          target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
          // Does a scroll target exist?
          if (target.length) {
            // Only prevent default if animation is actually gonna happen
            event.preventDefault();

            let heightHeader = $('header.banner').outerHeight(true);
            $('html, body').animate({
              scrollTop: target.offset().top - heightHeader,
            }, 1000, function () {
              // Callback after animation
              var $target = $(target);
              $target.focus();
              if ($target.is(':focus')) { // Checking if the target was focused
                return false;
              } else {
                $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
                $target.focus(); // Set focus again
              }
            })
          }
        }
      });

    $(window).scroll(() => {
      // Distance from top of document to top of footer.
      let topOfFooter = $('.main-footer').position().top;
      // Distance user has scrolled from top, adjusted to take in height of sidebar (950 pixels inc. padding).
      let scrollDistanceFromTopOfDoc = $(document).scrollTop() + 950;
      // Difference between the two.
      let scrollDistanceFromTopOfFooter = scrollDistanceFromTopOfDoc - topOfFooter;

      // If user has scrolled further than footer,
      // pull sidebar up using a negative margin.
      if (scrollDistanceFromTopOfDoc > topOfFooter) {
        $('.floating-box-contact').css('margin-top', 0 - scrollDistanceFromTopOfFooter);
      } else {
        $('.floating-box-contact').css('margin-top', 0);
      }
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js